import * as types from '../actions/actionTypes';

export const currentUserPage = (state = {Data : [], PageSize : 50, TotalPageCount : 1, PageIndex : 1, Loading : true}, action) => {
  switch(action.type){
    case types.FETCH_USERS : 
    case types.FETCH_USERS_REJECTED:
      return {Data : [], TotalPageCount : 1, PageIndex : 1, PageSize : 50,Loading : true};
    case types.FETCH_USERS_FULFILLED:
      return {...action.payload, Loading : false};
    default :
      return state;
  }
}


export const currentEditUser = (state = {User : {}, Loading : true}, action) => {
  switch(action.type){
    case types.FETCH_EDIT_USER : 
    case types.FETCH_EDIT_USER_REJECTED:
      return {Data : [], TotalPageCount : 1, PageIndex : 1, PageSize : 50,Loading : true};
    case types.FETCH_EDIT_USER_FULFILLED:
      return { User : action.payload, Loading : false};
    default :
      return state;
  }
}





// WEBPACK FOOTER //
// ./reducers/usersReducer.js